<template>
  <section class="relative pt-24 pb-16 md:pt-28 md:pb-24 bg-[#1E2652]">
    <div class="container mx-auto px-4 md:px-6 max-w-6xl">
      <!-- Header -->
      <div class="mb-10 md:mb-14 text-center">
        <h1 class="text-3xl md:text-4xl font-bold text-white tracking-tight">
          Mentions Légales
        </h1>
        <div class="mt-3 inline-flex items-center gap-2 rounded-full bg-white/10 text-gray-200 px-3 py-1 text-sm">
          <span class="h-2 w-2 rounded-full bg-[#B7E000]"></span>
          <span>Dernière mise à jour : {{ new Date().toLocaleDateString('fr-FR') }}</span>
        </div>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-12 gap-8">
        <!-- TOC -->
        <aside class="hidden md:block md:col-span-4 lg:col-span-3">
          <nav class="sticky top-24 bg-white/5 border border-white/10 rounded-xl p-4">
            <h2 class="text-sm font-semibold text-gray-200 mb-3">Sommaire</h2>
            <ul class="space-y-2">
              <li v-for="item in toc" :key="item.slug">
                <a :href="'#' + item.slug" class="toc-link block text-sm text-gray-300 hover:text-white">
                  {{ item.title }}
                </a>
              </li>
            </ul>
          </nav>
        </aside>

        <!-- Content -->
        <main class="md:col-span-8 lg:col-span-9">
          <div class="bg-white/[0.04] border border-white/10 rounded-2xl p-6 md:p-8">
            <section v-for="(section, index) in legalSections" :key="index" class="pt-4 first:pt-0 border-t border-white/10 first:border-t-0">
              <h2 class="text-xl md:text-2xl font-semibold text-[#B7E000] mb-3 scroll-mt-28" :id="toc[index].slug">
                {{ section.title }}
              </h2>
              <div class="text-gray-200 leading-relaxed space-y-4" v-html="section.content"></div>
            </section>
          </div>

          <!-- Contact Section -->
          <div class="text-center mt-10">
            <h3 class="text-lg font-semibold text-white mb-3">Questions ?</h3>
            <p class="text-gray-300 mb-5">Pour toute question relative à nos mentions légales, contactez-nous à :</p>
            <a href="mailto:contact@padelgo.ma" class="inline-flex items-center px-6 py-3 rounded-full bg-[#B7E000] text-[#1E2652] font-medium hover:bg-[#B7E000]/90 transition-colors">contact@padelgo.ma</a>
          </div>
        </main>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
function slugifyTitle(title: string): string {
  return title
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, '')
    .trim()
    .replace(/\s+/g, '-')
}

const legalSections = [
  {
    title: '1. Éditeur du site',
    content: `
      <p>
        RAYAN MARSILE CORP<br>
        SARL AU au capital de 10 000 dirhams<br>
        Siège social : 45 avenue de France, apt 8 Agdal Rabat<br>
        Immatriculée au registre de commerce de Rabat sous le N° RC 184873<br>
        Email : contact@padelgo.ma
      </p>
    `
  },
  {
    title: '2. Hébergement',
    content: `
      <p>
        Hostinger International Ltd.<br>
        Lordou Vyrona 61, Larnaca 7550, Chypre<br>
        Serveur hébergé au Royaume-Uni<br>
        +370 645 03378
      </p>
    `
  },
  {
    title: '3. Propriété intellectuelle',
    content: `
      <p>
        L'ensemble des éléments constituant le site PadelGo (textes, graphismes, logiciels, photographies, images, vidéos, sons, plans, logos, marques, etc.) sont la propriété exclusive de PadelGo ou de ses partenaires. Toute reproduction, représentation, modification, publication, adaptation de tout ou partie des éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite, sauf autorisation écrite préalable de PadelGo.
      </p>
    `
  },
  {
    title: '4. Protection des données personnelles',
    content: `
      <p>
        Conformément à la loi 09-08 relative à la protection des personnes physiques à l'égard du traitement des données à caractère personnel, vous disposez d'un droit d'accès, de rectification et de suppression des données vous concernant. Pour exercer ce droit, vous pouvez nous contacter à l'adresse email suivante : contact@padelgo.ma
      </p>
    `
  },
  {
    title: '5. Droit applicable',
    content: `
      <p>
        Les présentes mentions légales sont soumises au droit marocain. En cas de litige, les tribunaux marocains seront seuls compétents.
      </p>
    `
  }
]

const toc = legalSections.map((s) => ({ title: s.title, slug: slugifyTitle(s.title) }))
</script>

<style scoped>
.toc-link {
  transition: color 0.15s ease;
}
</style>